import React, { useState } from "react";
import { BtnPrimary } from "../../Components/share/buttons/Btn";
import { ReactComponent as Trash } from "../../Assets/Image/svg/trash.svg";
import { ReactComponent as Edit } from "../../Assets/Image/svg/edit.svg";
import { Modal } from "../../Components/share/modal/Modal";
import NewRollModal from "../../Components/layouts/AdminDashboard/NewRollModal";

function Rolles() {
  const [newRoll, setNewRoll] = useState(false);
  return (
    <div>
      {" "}
      <div className=" flex SupportTicket__header justify-between items-center leading-[3.2rem] mt-[4.5rem]">
        <h3 className=" text-[#77498F] text-[1.6rem] font-bold leading-[3.2rem] ">
          اطلاعات افراد بوت کمپ
        </h3>
        <BtnPrimary
          text="+  ساخت دسترسی جدید"
          className=" px-12 py-8 "
          onClick={() => setNewRoll(true)}
        />
      </div>
      <div className=" mt-[4.5rem]">
        <div className=" rounded-3xl overflow-hidden border-2 border-solid border-light-prim2">
          <div className="accessibility-card-auto accessibility-body bg-purple-dark-1 mb-4 font-bold text-black-prim">
            <div>نام</div>
            <div>سمت</div>
            <div>شماره تماس</div>
            <div>وضعیت</div>
            <div></div>
          </div>
          {discounts.map((i) => (
            <div
              key={i.id}
              className="accessibility-card-auto accessibility-body  my-4 relative"
            >
              <div className=" text-black-prim">{i.name}</div>
              <div>{i.rolle}</div>
              <div className=" text-purple-dark cursor-pointer">{i.phone}</div>
              <div className=" text-purple-dark cursor-pointer">
                {i.situation ? (
                  <p className=" text-[#2E7D32] font-normal  leading-[2.4rem]">
                    تایید شده
                  </p>
                ) : (
                  <p className="text-[#B00020] font-normal leading-[2.4rem]">
                    تایید نشده
                  </p>
                )}
              </div>
              <div className="">
                {!i.checked && (
                  <div className="flex justify-around">
                    {!i.situation ? (
                      <div className="flex flex-col justify-center items-center cursor-pointer">
                        <Trash />
                      </div>
                    ) : (
                      <div className="flex flex-col justify-center items-center opacity-0">
                        <Trash />
                      </div>
                    )}

                    <div className="flex flex-col cursor-pointer">
                      <Edit />
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <Modal show={newRoll}>
        <NewRollModal close={setNewRoll} />
      </Modal>
    </div>
  );
}

export default Rolles;

const discounts = [
  {
    name: "دانشگاه صنعتی اصفهان",
    rolle: "برگزار کننده",
    phone: "۰۹۱۳۸۲۷۲۸۱۵",
    situation: true,
  },
  {
    name: "علی مشیری",
    rolle: "استاد",
    phone: "۰۹۱۳۸۲۷۲۸۱۵",
    situation: false,
  },
  {
    name: "علی مشیری",
    rolle: "استاد",
    phone: "۰۹۱۳۸۲۷۲۸۱۵",
    situation: false,
  },
  {
    name: "دانشگاه صنعتی اصفهان",
    rolle: "برگزار کننده",
    phone: "۰۹۱۳۸۲۷۲۸۱۵",
    situation: true,
  },
];
